import { Navigate, useRoutes } from 'react-router-dom';
import { PATHS } from './paths';
import { authRoutes } from './auth_routes';
import { dashboardRoutes } from './dashboard_routes';

export default function Router() {
  return useRoutes([
    {
      path: PATHS.home,
      element: (
        <Navigate
          to={PATHS.auth.login}
          replace
        />
      ),
    },

    ...authRoutes,
    ...dashboardRoutes,

    {
      path: '*',
      element: (
        <Navigate
          to={PATHS.home}
          replace
        />
      ),
    },
  ]);
}
